/** Euro amount in French notation: 2 decimals from 1 €, up to 4 below so a fraction of a cent stays visible. */
const formatEuros = (amount: number): string => {
	return new Intl.NumberFormat('fr-FR', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 2,
		maximumFractionDigits: amount < 1 ? 4 : 2,
	}).format(amount);
};

export default formatEuros;
